export default {
    url: '',
    template: '<manage-settings-tasklist-templates-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/settings/tasklist/templates/list/index.js